RivalIQ.apps.Admin.apps.Company.module('views', function (views, App, Backbone, Marionette, $, _) {

    'use strict';

    views.HandlePickerItem = Marionette.CompositeView.extend({
        template: '#adminCompanyHandlePickerItemTemplate',
        tagName: 'li',
        className: 'list-group-item',

        ui: {
            addHandleBtn: '.x-add-handle',
            addPrimaryHandleBtn: '.x-add-primary-handle'
        },

        events: {
            'click @ui.addHandleBtn': 'addHandle',
            'click @ui.addPrimaryHandleBtn': 'addPrimaryHandle'
        },

        templateHelpers: function () {
            const me = this;
            const model = me.model.toJSON();
            const handles = me.options.handles;

            const defaults = {
                followers: 'n/a',
                posts: 'n/a',
                img_url: undefined,
                url: undefined,
                origin: undefined,
                score: undefined,
                inList: handles && handles.find(function (handle) {
                    return handle.get('native_id') === model.native_id;
                })
            };

            const overrides = {
                bio: me.trimBio(model.bio),
                score: (model.score ? me.formatScores(model.score) : undefined)
            };

            return _.extend(defaults, model, overrides);
        },

        trimBio: function (bio) {
            if (bio) {
                bio = $.trim(bio.replace(/<[^>]*>?/g, ' ').replace(/\s+/g, ' '));

                if (bio.length > 256) {
                    return `${bio.slice(0, 256)}...`;
                }
            }

            return bio || '';
        },

        formatScores: function (scores) {
            const me = this;

            return _.reduce(scores, function (memo, v, k) {
                memo[k] = {
                    value: me.formatNumber(v),
                    class: me.getLabelClass(k, v)
                };
                return memo;
            }, {});
        },

        formatNumber: function (num) {
            if (_.isUndefined(num)) {
                return '--';
            }

            if (num === Number.MAX_VALUE) {
                return '∞';
            }

            return RivalIQ.formatter.formats.fixed(num);
        },

        getLabelClass: function (type, score) {
            switch (type) {
                case 'domainScore':
                case 'bioScore':
                    if (score <= 3) {
                        return 'label-success';
                    }
                    if (score < 100) {
                        return 'label-warning';
                    }
                    return 'label-default';
                case 'nameScore':
                    if (score <= 0.5) {
                        return 'label-success';
                    }
                    if (score < 2) {
                        return 'label-warning';
                    }
                    return 'label-default';
                default:
                    throw new Error(`unknown label type ${type}`);
            }
        },

        addHandle: function () {
            const me = this;
            me.addHandleWithValidation();
        },

        addPrimaryHandle: function () {
            const me = this;
            me.addHandleWithValidation({
                is_primary: true
            });
        },

        addHandleWithValidation: function (extraProperties) {

            // NOTE run validation on any handle that the admin selects, so that we are guaranteed that it is valid
            // and all expected properties are present

            const me = this;

            const handleModel = RivalIQ.models.SocialHandle.build(me.model);

            const deferred = RivalIQ.utils.async.callbackToDeferred(function (error) {
                if (error) {
                    return RivalIQ.execute('alert:error', error);
                } else {
                    me.options.handles.push(_.extend(extraProperties || {}, handleModel.toJSON()));
                }
            });

            handleModel.fetch().done(deferred.resolve).fail(deferred.reject);
        }
    });
});
